module.exports = __webpack_public_path__ + "static/media/pdo-logo.14644bc8.png";